// extracted by mini-css-extract-plugin
export default {"avatarListBox":"h5_avatarListBox__D6qXK","avatar":"h5_avatar__ox0-e"};